import Vue from 'vue'
import Vuex from 'vuex'
import cookies from 'js-cookie'
import { applyMixin } from './storeMixin'
import actions from './actions'
import { getOsType } from '@/utils/utils'

Vue.use(Vuex)

const requireModules = require.context('./modules', false, /\.js$/)
const modules = requireModules.keys().reduce((modules, fileName) => {
  const name = fileName.match(/([^./]+)\.js$/)[1]
  modules[name] = requireModules(fileName).default
  return modules
}, {})

export default new Vuex.Store(
  applyMixin({
    state: {
      memberStatus: cookies.get('memberStatus'),
      ncpCertificated: cookies.get('ncpCertificated') === 'true',
      ncpMemberAgree: cookies.get('ncpMemberAgree') === 'Y',
      appVersion: cookies.get('appVersion'),
      osType: function () {
        return getOsType()
      }
    },
    actions,
    modules
  })
)
